import { type ReactionOption } from "../reactions";

import clownSoundOgg from "../sound/reactions/clown.ogg?url";
import clownSoundMp3 from "../sound/reactions/clown.mp3?url";
import poopSoundOgg from "../sound/reactions/poop.ogg?url";
import poopSoundMp3 from "../sound/reactions/poop.mp3?url";

export const MyCustomReactions: ReactionOption[] = [
  {
    emoji: "🤡",
    name: "clown",
    alias: ["fool", "joke", "circus"],
    sound: {
      ogg: clownSoundOgg,
      mp3: clownSoundMp3,
    },
  },
  {
    emoji: "💩",
    name: "poop",
    alias: ["crap", "shit", "poo"],
    sound: {
      ogg: poopSoundOgg,
      mp3: poopSoundMp3,
    },
  },
];
